import React from 'react';
import PreLoginPage from '../../views/core/PreLoginPage';
import UserStore from '../../util/UserStore';

export default class LumosLogin extends PreLoginPage{

	constructor(props) {
		super(props);
		this.UserStore = new UserStore();
	}

	componentDidMount(){
		let me = this;

		let success = (userObj) => {
			if(typeof userObj === "object" && userObj.authToken){
				me.UserStore.set(userObj);	
				let afterUpdate = function(){
					window.location.href = "/landing";
				};
				me.updateUserType(afterUpdate);
				
			}else{
				console.warn("Lumos user not logged in PLP system yet.");

				window.location.href = "/";
			}
			
		}

		let failure = (error) => {
			console.warn("Lumos user not logged in PLP system failure.", error);

			window.location.href = "/";
		}

		this.sessionCheck(success, failure, true);
	}

	render() {			
		return (  
			<div> {this.showLoader()}</div>
			);
	}

}


// WEBPACK FOOTER //
// ./src/views/extlogin/LumosLogin.js